import { getDictByCode } from '@/api/browse'

const state = {
  productTypes: [],
  themes: [],
  routes: [],
  cities: [],
  articleTypes: [],
  loading: false
}

const mutations = {
  SET_DICT(state, { key, data }) {
    state[key] = data
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}

const actions = {
  async loadDict({ commit, state }, typeCode) {
    const keyMap = {
      'product_type': 'productTypes',
      'theme': 'themes',
      'route': 'routes',
      'city': 'cities',
      'article_type': 'articleTypes'
    }

    const key = keyMap[typeCode]
    if (!key) return

    // 如果已加载，直接返回
    if (state[key].length > 0) return state[key]

    commit('SET_LOADING', true)
    try {
      const res = await getDictByCode(typeCode)
      commit('SET_DICT', { key, data: res.data || [] })
      return res.data
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  productTypes: state => state.productTypes,
  cities: state => state.cities,
  articleTypes: state => state.articleTypes
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
